(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aliencell-header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky =
this.getAttribute('data-sticky-type') === 'always' ||
this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
}

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach((disclosure) => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aliencell-main-article"]) return;
  try {
    
(() => {
  const initializeArticle = (root) => {
    const content = root.querySelector('[data-a-article-content]');
    if (!content || content.dataset.aArticleReady === 'true') return;
    content.dataset.aArticleReady = 'true';

    const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (headings.length) {
      // Preserve existing anchors unless they collide with another element on the page.
      const idCounts = new Map();
      document.querySelectorAll('[id]').forEach((element) => {
        idCounts.set(element.id, (idCounts.get(element.id) || 0) + 1);
      });
      const navigation = document.createElement('nav');
      navigation.className = 'a-article__toc';
      navigation.setAttribute('aria-label', 'In This Guide');
      const title = document.createElement('p');
      title.className = 'a-article__toc-title';
      title.textContent = 'In This Guide';
      const list = document.createElement('ul');

      headings.forEach((heading, index) => {
        if (!heading.id || idCounts.get(heading.id) > 1) {
          if (heading.id) idCounts.set(heading.id, idCounts.get(heading.id) - 1);
          const base = `a-article-${root.dataset.aArticle}-heading-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
          idCounts.set(id, 1);
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'start',
          });
          // Keep native fragment/history behavior without reloading the Shopify editor iframe.
          if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
        });
        item.append(link);
        list.append(item);
      });
      navigation.append(title, list);
      let insertionPoint = headings[0];
      while (insertionPoint.parentElement !== content) insertionPoint = insertionPoint.parentElement;
      content.insertBefore(navigation, insertionPoint);
    }

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement.closest('table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'a-article__table-wrap';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || 'Article table');
      table.before(wrapper);
      wrapper.append(table);

      const rows = Array.from(table.rows);
      const header = table.tHead ? table.tHead.rows[0] : rows[0];
      if (!header || (table.tHead && table.tHead.rows.length !== 1) || table.tFoot || table.querySelector('table')) return;
      const columns = Array.from(header.cells);
      const bodyRows = rows.filter((row) => row !== header);
      const hasSpans = rows.some((row) => Array.from(row.cells).some((cell) => cell.colSpan !== 1 || cell.rowSpan !== 1));
      const validHeader = columns.length && columns.every((cell) => cell.tagName === 'TH' && cell.scope !== 'row' && cell.textContent.trim());
      const validBody = bodyRows.length && bodyRows.every((row) => row.cells.length === columns.length && Array.from(row.cells).every((cell) => cell.scope !== 'col'));
      if (hasSpans || !validHeader || !validBody) return;

      header.classList.add('a-article__table-header');
      table.classList.add('a-article__table-cards');
      table.setAttribute('role', 'table');
      table.querySelectorAll('thead, tbody').forEach((group) => group.setAttribute('role', 'rowgroup'));
      rows.forEach((row) => row.setAttribute('role', 'row'));
      columns.forEach((cell) => {
        cell.scope = 'col';
        cell.setAttribute('role', 'columnheader');
      });
      bodyRows.forEach((row) => {
        Array.from(row.cells).forEach((cell, index) => {
          if (!cell.hasAttribute('data-label')) cell.dataset.label = columns[index].textContent.trim();
          const isRowHeader = cell.tagName === 'TH';
          if (isRowHeader) cell.scope = 'row';
          cell.setAttribute('role', isRowHeader ? 'rowheader' : 'cell');
          const value = document.createElement('span');
          value.className = 'a-article__cell-value';
          value.append(...Array.from(cell.childNodes));
          cell.append(value);
        });
      });
    });

    content.querySelectorAll('img').forEach((image) => {
      if (!image.hasAttribute('loading')) image.loading = 'lazy';
    });
  };

  const initializeWithin = (scope) => {
    if (scope.matches?.('[data-a-article]')) initializeArticle(scope);
    scope.querySelectorAll('[data-a-article]').forEach(initializeArticle);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
